import Vue from "vue";

export default {
    recuperarTiposNecessidadeEspecial() {
        return Vue.axios.get("tipoNecessidadeEspecial");
    },


};